module.exports = __webpack_public_path__ + "img/ex6.ec403e46.png";